import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { RootStore, withInjectedRootStore } from 'providers';
import s from './Cycles.scss';

const CyclesHeadingComp: React.FC<{ rootStore: RootStore }> = ({
  rootStore,
}) => {
  const {
    currentProduct: { productName },
  } = rootStore.appStore;
  const { t } = useTranslation();
  return (
    <div data-hook='cycle-heading' className={s.cycleHeading}>
      <h4 className={s.title}>
        {t('subscription_page.cycle_heading.title', {
          productName,
        })}
      </h4>
    </div>
  );
};

export const CyclesHeading = withInjectedRootStore(CyclesHeadingComp);
